// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"b5dc9d8c","23":"43f7088c","49":"f84b19e0","125":"68ae0af9","134":"c02eb7b4","209":"42937fce","242":"c045c8a3","252":"4a4d23d9","331":"c69089bd","781":"49da8962","787":"c4e7f8f9","856":"04afce18","970":"b8e3cd11"}[chunkId] + ".chunk.js";
};